<template>

  <v-card v-if="order" class="route-builder-undeliverable-order-card">
    <v-container fluid>
      <v-row>
        <v-col cols="12" xs="12" sm="9" md="8" lg="10" class="pb-3">
          <!-- Order Number, Brand -->
          <v-row>
            <v-col cols="12" class="d-flex align-center">
              <div class="order-number">
                Order: {{ order.order_number }}
              </div>
              <div class="ml-2 d-flex align-center brand-name" v-if="brandName">
                <div class="mr-2">-</div>
                <div>{{ brandName }}</div>
              </div>
            </v-col>
          </v-row>
          <!-- To / From -->
          <v-row class="mt-0">
            <v-col cols="12" class="d-flex align-center">
              <div class="ml-2 loc-info">
                <v-icon size="15" color="white">mdi-map-marker-outline</v-icon>
                <span class="ml-2 loc-label">
                  <a @click="goToShipperPage">{{ shipperLocationName }}</a>
                </span>
              </div>
              <div class="mt-1 mb-1 loc-info label-delivering-to">
                to
              </div>
              <div class="ml-2 loc-info">
                <v-icon size="15" color="white">mdi-map-marker-outline</v-icon>
                <span class="ml-2 loc-label">
                  <a @click="goToReceiverPage">{{ receiverLocationName }}</a>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" sm="3" md="4" lg="2" class="pr-8 d-flex flex-column align-center justify-start">
          <div class="label" style="margin-bottom:4px;">
            Rescheduled At
          </div>
          <div class="affected-date">
            {{ rescheduledDateForDisplay }}
          </div>
          <div class="mt-1 affected-time">
            {{ rescheduledTimeForDisplay }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>

</template>

<script>
export default {
  name: 'RouteBuilderUndeliverableOrderCard',

  props: {
    order: {
      type: Object,
      default: null
    },
    orderIndex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    orderIndexForDisplay () {
      return (this.order.estimated_receiver_arrival_time)
        ? this.orderIndex
        : '-'
    },
    shipperLocationName () {
      return (this.order.shipper) ? this.order.shipper.name : '-'
    },
    brandName () {
      return this.order.thirdparty_brand_name
    },
    receiver () {
      return this.order.receiver || {}
    },
    receiverLocationName () {
      return (this.order.receiver) ? this.order.receiver.name : '-'
    },
    rescheduledDateForDisplay () {
      return (this.order.rescheduled_at)
        ? this.$root.utils.dateFormat(this.order.rescheduled_at, 'MMM D, YYYY')
        : '-'
    },
    rescheduledTimeForDisplay () {
      return (this.order.rescheduled_at)
        ? this.$root.utils.dateFormat(this.order.rescheduled_at, 'h:mm a')
        : ''
    }
  },

  methods: {
    // Go to the shipper page
    goToShipperPage () {
      if (this.order.shipper) this.$root.goTo('shipper-item', { shipperId: this.order.shipper.id })
    },

    // Go to the receiver page
    goToReceiverPage () {
      if (this.order.receiver) this.$root.goTo('receiver-item', { receiverId: this.order.receiver.id })
    }
  }
}

</script>

<style>
  /* ------------------------------------------------------------- title-area */

  .route-builder-undeliverable-order-card .label {
    color: #9c9c9c;
    font-size: 14px;
  }

  .route-builder-undeliverable-order-card .order-number {
    font-size: 22px !important;
  }

  .route-builder-undeliverable-order-card .brand-name {
    font-size: 1.04rem;
    color: #9c9c9c;
  }

  /* --------------------------------------------------------- date/time info */

  .route-builder-undeliverable-order-card .affected-date {
    font-size: 16px;
  }

  .route-builder-undeliverable-order-card .affected-time {
    font-size: 14px;
    color: #9c9c9c;
  }

  /* --------------------------------------------------------------- loc-info */

  .route-builder-undeliverable-order-card .loc-info {
    color: #9c9c9c;
    font-size: 14px;
  }

  .route-builder-undeliverable-order-card .label-delivering-to {
    color: #525252;
    font-size: 13px;
    text-align: center;
    margin-left: 18px;
    margin-right: 9px;
  }
</style>
